module.exports = __webpack_public_path__ + "static/media/Icon1-4.8a3f0738.png";